
(function(){
  // ─── 1. TRUST STRIP (below header) ────────────────────────────
  function addTrustStrip(){
    if(document.getElementById('trust-strip')) return;
    const strip = document.createElement('div');
    strip.id = 'trust-strip';
    strip.style.cssText='background:#f8f8fb;border-top:1px solid #eee;border-bottom:1px solid #eee;padding:14px 16px;font:500 12px -apple-system,Inter,sans-serif;color:#333';
    strip.innerHTML = `
      <div style="max-width:1200px;margin:0 auto;display:flex;justify-content:space-around;gap:12px;flex-wrap:wrap;text-align:center">
        <div style="display:flex;align-items:center;gap:8px"><span style="font-size:20px">🚚</span><div><strong>Free shipping €50+</strong><br><span style="color:#888;font-size:11px">Across Europe</span></div></div>
        <div style="display:flex;align-items:center;gap:8px"><span style="font-size:20px">↩️</span><div><strong>14-day returns</strong><br><span style="color:#888;font-size:11px">Hassle-free</span></div></div>
        <div style="display:flex;align-items:center;gap:8px"><span style="font-size:20px">🔒</span><div><strong>Secure checkout</strong><br><span style="color:#888;font-size:11px">iDEAL · Klarna · Card</span></div></div>
        <div style="display:flex;align-items:center;gap:8px"><span style="font-size:20px">⭐</span><div><strong>5-star service</strong><br><span style="color:#888;font-size:11px">Reply within 24h</span></div></div>
      </div>`;
    const header = document.querySelector('header') || document.querySelector('.header') || document.body.firstElementChild;
    if(header && header.parentNode) header.parentNode.insertBefore(strip, header.nextSibling);
  }

  // ─── 2. EMAIL SIGNUP POPUP ────────────────────────────────────
  function showSignupPopup(){
    const key='itf_signup_dismissed';
    const seen=localStorage.getItem(key);
    if(seen && (Date.now()-parseInt(seen,10)) < 7*24*3600*1000) return;
    const overlay=document.createElement('div');
    overlay.id='itf-popup';
    overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;animation:itfFade .3s';
    overlay.innerHTML=`
      <style>@keyframes itfFade{from{opacity:0}to{opacity:1}}@keyframes itfSlide{from{transform:translateY(20px);opacity:0}to{transform:translateY(0);opacity:1}}</style>
      <div style="background:#fff;border-radius:16px;max-width:440px;width:100%;padding:32px;text-align:center;position:relative;animation:itfSlide .4s;box-shadow:0 20px 60px rgba(0,0,0,.3)">
        <button id="itf-close" style="position:absolute;top:12px;right:12px;background:none;border:none;font-size:24px;cursor:pointer;color:#999;width:32px;height:32px">×</button>
        <div style="font-size:48px;margin-bottom:8px">🎁</div>
        <h2 style="font:700 22px -apple-system,Inter,sans-serif;margin:0 0 8px;color:#111">Get 10% off your first order</h2>
        <p style="color:#666;font:14px/1.5 -apple-system,Inter,sans-serif;margin:0 0 20px">Join 1,200+ happy customers. One quality tip per month — no spam, ever.</p>
        <form id="itf-form" style="display:flex;flex-direction:column;gap:10px">
          <input required type="email" placeholder="your@email.com" style="padding:14px 16px;border:1.5px solid #ddd;border-radius:10px;font:15px -apple-system,Inter,sans-serif;outline:none">
          <button type="submit" style="padding:14px;background:linear-gradient(90deg,#7c5cff,#22d3ee);color:#fff;border:none;border-radius:10px;font:700 15px -apple-system,Inter,sans-serif;cursor:pointer;letter-spacing:.3px">Claim 10% off →</button>
        </form>
        <p style="color:#aaa;font-size:11px;margin-top:14px">Use code <strong>WELCOME10</strong> at checkout</p>
      </div>`;
    document.body.appendChild(overlay);
    const close=()=>{localStorage.setItem(key,Date.now().toString());overlay.remove();};
    overlay.querySelector('#itf-close').onclick=close;
    overlay.onclick=(e)=>{if(e.target===overlay)close();};
    overlay.querySelector('#itf-form').onsubmit=(e)=>{
      e.preventDefault();
      const email=e.target.querySelector('input').value;
      fetch('/contact#contact_form',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:`form_type=customer&contact[email]=${encodeURIComponent(email)}&contact[accepts_marketing]=true`}).catch(()=>{});
      overlay.querySelector('div[style*="background:#fff"]').innerHTML='<div style="padding:40px 20px;text-align:center"><div style="font-size:48px">✅</div><h2 style="font:700 22px -apple-system;color:#111;margin:12px 0 8px">You\'re in!</h2><p style="color:#666">Your 10% code is <strong style="color:#7c5cff;font-size:18px">WELCOME10</strong><br>Use it at checkout.</p></div>';
      setTimeout(close, 3500);
    };
  }

  // ─── 3. RELATED PRODUCTS (product page only) ──────────────────
  function loadRelated(){
    if(!location.pathname.includes('/products/')) return;
    if(document.getElementById('itf-related')) return;
    fetch('/products.json?limit=12').then(r=>r.json()).then(d=>{
      const slug=location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
      const others=(d.products||[]).filter(p=>p.handle!==slug).slice(0,4);
      if(!others.length) return;
      const section=document.createElement('section');
      section.id='itf-related';
      section.style.cssText='max-width:1200px;margin:48px auto;padding:0 16px;font:-apple-system,Inter,sans-serif';
      section.innerHTML=`
        <h2 style="font:700 22px -apple-system,Inter,sans-serif;margin-bottom:20px;color:#111">You might also like</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:16px">
          ${others.map(p=>{
            const img=p.images?.[0]?.src||'';
            const price=(p.variants?.[0]?.price)||'';
            return `<a href="/products/${p.handle}" style="text-decoration:none;color:inherit;display:block;border:1px solid #eee;border-radius:12px;overflow:hidden;transition:transform .2s,box-shadow .2s" onmouseover="this.style.transform='translateY(-2px)';this.style.boxShadow='0 8px 24px rgba(0,0,0,.08)'" onmouseout="this.style.transform='';this.style.boxShadow=''"><div style="aspect-ratio:1;background:#f6f6f6 url('${img}') center/cover"></div><div style="padding:12px"><div style="font-weight:600;font-size:13px;color:#111;margin-bottom:4px;line-height:1.3;min-height:34px">${p.title}</div><div style="font-weight:700;color:#7c5cff;font-size:14px">€${price}</div></div></a>`;
          }).join('')}
        </div>`;
      const anchor=document.querySelector('main')||document.querySelector('.product')||document.body;
      anchor.appendChild(section);
    }).catch(()=>{});
  }

  // ─── 4. CART UPSELL PROGRESS BAR ──────────────────────────────
  // Shown on cart page/drawer: "Add €X more for 15% bundle discount" (real discount: BUNDLE15, €50+)
  function cartUpsell(){
    if(!location.pathname.includes('/cart')) return;
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      if(!cart.item_count) return;
      const total = cart.total_price/100;
      const freeShipThreshold = 50;
      const bundleThreshold   = 50;
      const remainingShip   = Math.max(0, freeShipThreshold - total);
      const remainingBundle = Math.max(0, bundleThreshold   - total);
      const progress = Math.min(100, (total/freeShipThreshold)*100);
      let msg;
      if(remainingShip > 0){
        msg = `Add <strong>€${remainingShip.toFixed(2)}</strong> more for <strong>FREE shipping</strong> & <strong>15% off</strong> with code <code style="background:#fff;padding:2px 6px;border-radius:4px;font-weight:700">BUNDLE15</code>`;
      } else {
        msg = `🎉 You've unlocked <strong>FREE shipping</strong>! Use code <code style="background:#fff;padding:2px 6px;border-radius:4px;font-weight:700">BUNDLE15</code> at checkout for <strong>15% off</strong>.`;
      }
      const banner = document.createElement('div');
      banner.id = 'itf-cart-upsell';
      banner.style.cssText='background:linear-gradient(90deg,#ede9fe,#cffafe);border-radius:12px;padding:16px;margin:16px auto;max-width:1200px;font:14px -apple-system,Inter,sans-serif;color:#333';
      banner.innerHTML = `
        <div style="margin-bottom:10px">${msg}</div>
        <div style="height:8px;background:#fff;border-radius:4px;overflow:hidden">
          <div style="height:100%;width:${progress}%;background:linear-gradient(90deg,#7c5cff,#22d3ee);transition:width .4s"></div>
        </div>`;
      const anchor = document.querySelector('main') || document.querySelector('.cart') || document.body.firstElementChild;
      if(anchor && !document.getElementById('itf-cart-upsell')){
        anchor.insertBefore(banner, anchor.firstChild);
      }
    }).catch(()=>{});
  }

  // ─── 5. EXIT-INTENT POPUP ─────────────────────────────────────
  // Fires when mouse leaves viewport at top (desktop) — offers WELCOME10
  function exitIntent(){
    const key='itf_exit_shown';
    if(sessionStorage.getItem(key)) return;
    if(localStorage.getItem('itf_signup_dismissed')) return; // already seen signup
    if(window.innerWidth < 768) return; // skip on mobile
    let armed=false;
    setTimeout(()=>{armed=true;}, 5000); // arm after 5s browsing
    document.addEventListener('mouseleave', (e)=>{
      if(!armed) return;
      if(e.clientY > 0) return; // only top-edge exit
      if(sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key,'1');
      const overlay=document.createElement('div');
      overlay.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;animation:itfFade .3s';
      overlay.innerHTML=`
        <div style="background:#fff;border-radius:16px;max-width:460px;width:100%;padding:36px;text-align:center;position:relative;box-shadow:0 24px 60px rgba(0,0,0,.4)">
          <button id="ei-close" style="position:absolute;top:12px;right:12px;background:none;border:none;font-size:26px;cursor:pointer;color:#999">×</button>
          <div style="font-size:52px;margin-bottom:8px">👋</div>
          <h2 style="font:700 24px -apple-system,Inter,sans-serif;margin:0 0 8px;color:#111">Wait! Before you go…</h2>
          <p style="color:#555;font:15px/1.5 -apple-system,Inter,sans-serif;margin:0 0 18px">Here's <strong>10% off</strong> your first order. No strings attached.</p>
          <div style="background:#f6f2ff;padding:14px;border-radius:10px;margin-bottom:16px;font:15px -apple-system,Inter,sans-serif">
            Use code: <strong style="color:#7c5cff;font-size:20px;letter-spacing:2px">WELCOME10</strong>
          </div>
          <button id="ei-shop" style="padding:14px 28px;background:linear-gradient(90deg,#7c5cff,#22d3ee);color:#fff;border:none;border-radius:10px;font:700 15px -apple-system,Inter,sans-serif;cursor:pointer;width:100%">Keep shopping →</button>
          <p style="color:#aaa;font-size:11px;margin-top:12px">Ships worldwide · 7–14 days delivery</p>
        </div>`;
      document.body.appendChild(overlay);
      const close=()=>overlay.remove();
      overlay.querySelector('#ei-close').onclick=close;
      overlay.querySelector('#ei-shop').onclick=close;
      overlay.onclick=(e)=>{if(e.target===overlay)close();};
    });
  }

  // ─── 6. STICKY ADD-TO-CART (mobile product pages) ─────────────
  function stickyBuy(){
    if(!location.pathname.includes('/products/')) return;
    if(window.innerWidth >= 768) return;
    if(document.getElementById('itf-sticky-buy')) return;
    const mainBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"], button[name="add"]');
    if(!mainBtn) return;
    const bar = document.createElement('div');
    bar.id='itf-sticky-buy';
    bar.style.cssText='position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:1px solid #eee;padding:10px 12px;z-index:9998;display:flex;gap:8px;box-shadow:0 -4px 12px rgba(0,0,0,.08)';
    bar.innerHTML=`<button style="flex:1;padding:14px;background:linear-gradient(90deg,#7c5cff,#22d3ee);color:#fff;border:none;border-radius:10px;font:700 15px -apple-system,Inter,sans-serif">Add to cart</button>`;
    bar.querySelector('button').onclick=()=>mainBtn.click();
    document.body.appendChild(bar);
    // Hide when main btn in view
    const obs = new IntersectionObserver((entries)=>{
      bar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
    });
    obs.observe(mainBtn);
  }

  // ─── 7. RECENTLY VIEWED TRACKING ─────────────────────────────
  function trackRecentlyViewed(){
    if(!location.pathname.includes('/products/')) return;
    const slug = location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
    let list = JSON.parse(localStorage.getItem('itf_recent') || '[]');
    list = [slug, ...list.filter(s => s !== slug)].slice(0, 6);
    localStorage.setItem('itf_recent', JSON.stringify(list));
  }

  // ─── INIT ─────────────────────────────────────────────────────
  function init(){
    addTrustStrip();
    loadRelated();
    cartUpsell();
    stickyBuy();
    trackRecentlyViewed();
    exitIntent();
    setTimeout(showSignupPopup, 12000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* === BUNDLE WIDGETS === */
(function () {
  var BUNDLES = [
    {
      handle: 'ultimate-dog-grooming-kit',
      discount: 'GROOMINGKIT',
      variants: [57257601728894, 57257615720830, 57258705486206, 57257342534014],
      contains: [15860332626302, 15860335804798, 15860483162494, 15860252770686],
      label: 'Ultimate Dog Grooming Kit',
      save: '€34,85'
    },
    {
      handle: 'dog-road-trip-kit',
      discount: 'ROADTRIPKIT',
      variants: [57258716201342, 57257601728894, 57257734832510],
      contains: [15860484243838, 15860332626302, 15860342260094],
      label: 'Dog Road Trip Kit',
      save: '€54,90'
    },
    {
      handle: 'sleep-starter-kit',
      discount: 'SLEEPKIT',
      variants: [57201157964158, 57202701009278, 57202734825854],
      contains: [15846028149118, 15846648283518, 15846652707198],
      label: 'Sleep Starter Kit',
      save: '€22,02'
    }
  ];

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?]+)/);
    return m ? m[1] : null;
  }

  function currentProductId() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product)
        return window.ShopifyAnalytics.meta.product.id;
      if (window.meta && window.meta.product) return window.meta.product.id;
    } catch (e) {}
    return null;
  }

  function findAddForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function addBundleToCart(bundle, btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: bundle.variants.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/discount/' + bundle.discount + '?redirect=/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add Bundle to Cart — Save ' + bundle.save;
        alert('Something went wrong — please try again.');
      });
  }

  function renderBundleButton(bundle) {
    var form = findAddForm();
    if (!form) { setTimeout(function () { renderBundleButton(bundle); }, 400); return; }
    if (document.getElementById('itf-bundle-btn')) return;

    // Hide default submit buttons inside the add form
    form.querySelectorAll('button[type="submit"], [type="submit"]').forEach(function (b) {
      b.style.display = 'none';
    });

    var wrap = document.createElement('div');
    wrap.id = 'itf-bundle-btn';
    wrap.style.cssText = 'margin:14px 0;display:flex;flex-direction:column;gap:8px;';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Add Bundle to Cart — Save ' + bundle.save;
    btn.style.cssText = 'padding:14px 20px;background:#ff9500;color:#fff;border:0;border-radius:8px;font-weight:700;font-size:16px;cursor:pointer;';
    btn.onmouseover = function () { btn.style.background = '#e68600'; };
    btn.onmouseout  = function () { btn.style.background = '#ff9500'; };
    btn.onclick = function () { addBundleToCart(bundle, btn); };

    var note = document.createElement('div');
    note.style.cssText = 'font-size:12px;color:#555;';
    note.textContent = 'All items added at checkout, discount applies automatically — free shipping included.';

    wrap.appendChild(btn);
    wrap.appendChild(note);
    form.appendChild(wrap);
  }

  function renderCrossSellBanner(bundle) {
    var form = findAddForm();
    if (!form) { setTimeout(function () { renderCrossSellBanner(bundle); }, 400); return; }
    if (document.getElementById('itf-bundle-cross')) return;

    var banner = document.createElement('div');
    banner.id = 'itf-bundle-cross';
    banner.style.cssText = 'margin:16px 0;padding:14px 16px;background:linear-gradient(135deg,#fff7e6,#ffe4b5);border:2px solid #ff9500;border-radius:10px;';
    banner.innerHTML =
      '<div style="font-weight:700;font-size:15px;margin-bottom:6px;">🎁 Part of the ' + bundle.label + ' — save ' + bundle.save + '</div>' +
      '<div style="font-size:14px;margin-bottom:10px;">Buy this together with the rest of the kit at a discounted price. Free shipping included.</div>' +
      '<a href="/products/' + bundle.handle + '" style="display:inline-block;padding:8px 14px;background:#ff9500;color:#fff;text-decoration:none;border-radius:6px;font-weight:600;font-size:13px;">View ' + bundle.label + ' →</a>';

    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (btn && btn.parentNode) btn.parentNode.insertBefore(banner, btn.nextSibling);
    else form.appendChild(banner);
  }

  function init() {
    var handle = currentHandle();
    if (!handle) return;

    var bundle = BUNDLES.find(function (b) { return b.handle === handle; });
    if (bundle) { renderBundleButton(bundle); return; }

    var pid = currentProductId();
    if (!pid) return;
    var owning = BUNDLES.find(function (b) { return b.contains.indexOf(pid) !== -1; });
    if (owning) renderCrossSellBanner(owning);
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init);
  else
    init();
})();
/* === END BUNDLE WIDGETS === */
